import request from 'utils/request';

export default async function fetchTeams(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/masterData/distributorRepMapper/teams
      `,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
